<router-outlet></router-outlet>
<div class="version">v3.0.0</div>